<template>
<div id='stripBB'>
  <b-container class="containerStrip">
    <p class="ciclic-plataform">Uma empresa</p>
     <img src="https://static.ciclic.com.br/svg/bb-seguros-logo.svg"
      alt="Logo BB Seguros"
      class="bbseguros_logo"
      height="26"
      loading="lazy"
      width="150"
      />
  </b-container>
</div>
</template>

<script>
export default {
  name: 'StripBB'
}
</script>
<style src="./StripBB.css"></style>
